import { render } from "./CreateVcard.vue?vue&type=template&id=122c2026"
import script from "./CreateVcard.vue?vue&type=script&lang=js"
export * from "./CreateVcard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreavadacchino/Desktop/pADV/untitled/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__